"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.payableSaga = exports.getPayableDetailPage = exports.getPayableEventsById = exports.addAdjustments = exports.createOneOffLedgerItem = exports.settleLedgerItems = exports.regenerateLedgerItems = exports.deletePayable = exports.deleteAdjustment = exports.ignorePayable = exports.getAdjustmentsByLedgerItemId = exports.getAdjustments = exports.getPayableById = exports.getPayables = void 0;
var antd_1 = require("antd");
var uniq_1 = __importDefault(require("lodash/uniq"));
var effects_1 = require("redux-saga/effects");
var finance_client_1 = require("@evenfinancial/finance-client");
var api_client_1 = require("@portal/api-client");
var common_1 = require("@portal/common");
var loading_1 = require("../loading");
var actions_1 = require("../user/actions");
var actionTypes_1 = require("./actionTypes");
var actions = __importStar(require("./actions"));
var selectors_1 = require("./selectors");
function getPayables() {
    var payables, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4, (0, effects_1.call)([api_client_1.client, 'get'], '/finance/ledgerItems/payableSummaries', {
                        params: {
                            limit: 8000,
                            order: 'desc',
                        },
                    })];
            case 1:
                payables = (_a.sent()).data;
                if (!(payables === null || payables === void 0 ? void 0 : payables.length)) {
                    throw 'No payables returned from the backend';
                }
                return [4, (0, effects_1.put)(actions.payableRequestAction.success(payables))];
            case 2:
                _a.sent();
                return [3, 5];
            case 3:
                err_1 = _a.sent();
                return [4, (0, effects_1.put)(actions.payableRequestAction.failure(err_1))];
            case 4:
                _a.sent();
                return [3, 5];
            case 5: return [2];
        }
    });
}
exports.getPayables = getPayables;
function getPayableById(action) {
    var payable, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, 6, 8]);
                return [4, (0, effects_1.put)((0, loading_1.setIsLoadingAction)([loading_1.Resource.PayableById, true]))];
            case 1:
                _a.sent();
                return [4, (0, effects_1.call)([api_client_1.client, 'get'], "/finance/ledgerItems/".concat(action.payload.id))];
            case 2:
                payable = (_a.sent()).data;
                if (!(payable === null || payable === void 0 ? void 0 : payable.id)) {
                    throw 'No payables returned from the backend';
                }
                return [4, (0, effects_1.put)(actions.payableByIdRequestAction.success(payable))];
            case 3:
                _a.sent();
                return [3, 8];
            case 4:
                err_2 = _a.sent();
                return [4, (0, effects_1.put)(actions.payableByIdRequestAction.failure(err_2))];
            case 5:
                _a.sent();
                return [3, 8];
            case 6: return [4, (0, effects_1.put)((0, loading_1.setIsLoadingAction)([loading_1.Resource.PayableById, false]))];
            case 7:
                _a.sent();
                return [7];
            case 8: return [2];
        }
    });
}
exports.getPayableById = getPayableById;
function getAdjustments() {
    var params, adjustments, uuids, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 7]);
                params = {
                    ledgerItemType: finance_client_1.LedgerItemType.Payable,
                };
                return [4, (0, effects_1.call)(api_client_1.client.get, '/finance/accountAdjustments', { params: params })];
            case 1:
                adjustments = (_a.sent()).data;
                return [4, (0, effects_1.put)(actions.payableAdjustmentsRequestAction.success(adjustments))];
            case 2:
                _a.sent();
                return [4, (0, effects_1.select)(selectors_1.selectUniqAdjustmentUuids)];
            case 3:
                uuids = _a.sent();
                return [4, (0, effects_1.put)(actions_1.richAccessTokenByUuidRequestAction.request({
                        uuids: uuids,
                    }))];
            case 4:
                _a.sent();
                return [3, 7];
            case 5:
                err_3 = _a.sent();
                return [4, (0, effects_1.put)(actions.payableAdjustmentsRequestAction.failure(err_3))];
            case 6:
                _a.sent();
                return [3, 7];
            case 7: return [2];
        }
    });
}
exports.getAdjustments = getAdjustments;
function getAdjustmentsByLedgerItemId(action) {
    var ledgerItemId, params, adjustments, uuids, err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 6]);
                ledgerItemId = action.payload.ledgerItemId;
                params = {
                    ledgerItemIds: [ledgerItemId],
                    ledgerItemType: finance_client_1.LedgerItemType.Payable,
                };
                return [4, (0, effects_1.call)([api_client_1.client, 'get'], '/finance/accountAdjustments', { params: params })];
            case 1:
                adjustments = (_a.sent()).data;
                return [4, (0, effects_1.put)(actions.payableAdjustmentsByLedgerItemIdRequestAction.success({
                        adjustments: adjustments,
                        ledgerItemId: ledgerItemId,
                    }))];
            case 2:
                _a.sent();
                uuids = (0, uniq_1.default)(adjustments.map(function (a) { return a.createdBy; }));
                return [4, (0, effects_1.put)(actions_1.richAccessTokenByUuidRequestAction.request({
                        uuids: uuids,
                    }))];
            case 3:
                _a.sent();
                return [3, 6];
            case 4:
                err_4 = _a.sent();
                return [4, (0, effects_1.put)(actions.payableAdjustmentsByLedgerItemIdRequestAction.failure(err_4))];
            case 5:
                _a.sent();
                return [3, 6];
            case 6: return [2];
        }
    });
}
exports.getAdjustmentsByLedgerItemId = getAdjustmentsByLedgerItemId;
function ignorePayable(action) {
    var response, err_5, portalError;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 7]);
                return [4, (0, effects_1.call)([api_client_1.client, 'post'], '/finance/ledgerItems/create_ledger_item_reconciliation', {
                        ledgerItemIds: [action.payload.id],
                        memo: '',
                        reconciliationType: action.payload.reconciliationType,
                    })];
            case 1:
                response = (_a.sent()).data;
                return [4, (0, effects_1.put)(actions.payableIgnoreAction.success(response))];
            case 2:
                _a.sent();
                return [4, (0, effects_1.delay)(100)];
            case 3:
                _a.sent();
                return [4, (0, effects_1.call)(antd_1.message.success, 'Ledger item reconciliation updated successfully')];
            case 4:
                _a.sent();
                return [3, 7];
            case 5:
                err_5 = _a.sent();
                portalError = (0, common_1.getPortalError)(err_5);
                return [4, (0, effects_1.put)(actions.payableIgnoreAction.failure(portalError))];
            case 6:
                _a.sent();
                return [3, 7];
            case 7: return [2];
        }
    });
}
exports.ignorePayable = ignorePayable;
function deleteAdjustment(action) {
    var err_6, portalError;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 7]);
                return [4, (0, effects_1.call)([api_client_1.client, 'delete'], "/finance/accountAdjustments/".concat(action.payload.id))];
            case 1:
                _a.sent();
                return [4, (0, effects_1.put)(actions.payableAdjustmentDeleteAction.success(action.payload))];
            case 2:
                _a.sent();
                return [4, (0, effects_1.delay)(100)];
            case 3:
                _a.sent();
                return [4, (0, effects_1.call)([antd_1.message, 'success'], 'Payable adjustment successfully cancelled.')];
            case 4:
                _a.sent();
                return [3, 7];
            case 5:
                err_6 = _a.sent();
                portalError = (0, common_1.getPortalError)(err_6);
                return [4, (0, effects_1.put)(actions.payableAdjustmentDeleteAction.failure(portalError))];
            case 6:
                _a.sent();
                return [3, 7];
            case 7: return [2];
        }
    });
}
exports.deleteAdjustment = deleteAdjustment;
function deletePayable(action) {
    var router, err_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 7, , 9]);
                return [4, (0, effects_1.getContext)('Router')];
            case 1:
                router = _a.sent();
                return [4, (0, effects_1.call)([api_client_1.client, 'delete'], "/finance/ledgerItems/ledger_item_delete/".concat(action.payload.id))];
            case 2:
                _a.sent();
                return [4, (0, effects_1.call)([router, 'replace'], "".concat(location.origin, "/billing/payables"))];
            case 3:
                _a.sent();
                return [4, (0, effects_1.put)(actions.deletePayableAction.success({ id: action.payload.id }))];
            case 4:
                _a.sent();
                return [4, (0, effects_1.delay)(100)];
            case 5:
                _a.sent();
                return [4, (0, effects_1.call)([antd_1.message, 'success'], 'The payable was deleted')];
            case 6:
                _a.sent();
                return [3, 9];
            case 7:
                err_7 = _a.sent();
                return [4, (0, effects_1.put)(actions.deletePayableAction.failure(err_7))];
            case 8:
                _a.sent();
                return [3, 9];
            case 9: return [2];
        }
    });
}
exports.deletePayable = deletePayable;
function regenerateLedgerItems(action) {
    var _a, ledgerItemIds, copyAdjustments, ledgerItemsRegenerateData, e_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, , 7]);
                _a = action.payload, ledgerItemIds = _a.ledgerItemIds, copyAdjustments = _a.copyAdjustments;
                return [4, (0, effects_1.call)([api_client_1.client, 'post'], '/finance/ledgerItems/regenerate', {
                        copyAdjustments: copyAdjustments,
                        ledgerItemIds: ledgerItemIds,
                    })];
            case 1:
                ledgerItemsRegenerateData = (_b.sent()).data;
                return [4, (0, effects_1.put)(actions.regenerateLedgerItemsRequestAction.success(ledgerItemsRegenerateData))];
            case 2:
                _b.sent();
                return [4, (0, effects_1.delay)(100)];
            case 3:
                _b.sent();
                return [4, (0, effects_1.call)([antd_1.message, 'success'], 'Payables regenerated successfully')];
            case 4:
                _b.sent();
                return [3, 7];
            case 5:
                e_1 = _b.sent();
                return [4, (0, effects_1.put)(actions.regenerateLedgerItemsRequestAction.failure(e_1))];
            case 6:
                _b.sent();
                return [3, 7];
            case 7: return [2];
        }
    });
}
exports.regenerateLedgerItems = regenerateLedgerItems;
function settleLedgerItems(action) {
    var accountIds, ledgerItemSettlements, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 7]);
                accountIds = action.payload.accountIds;
                return [4, (0, effects_1.call)([api_client_1.client, 'post'], '/finance/ledgerItems/settlement', {
                        accountIds: accountIds,
                    })];
            case 1:
                ledgerItemSettlements = (_a.sent()).data;
                return [4, (0, effects_1.put)(actions.settleLedgerItemsRequestAction.success(ledgerItemSettlements))];
            case 2:
                _a.sent();
                return [4, (0, effects_1.delay)(100)];
            case 3:
                _a.sent();
                return [4, (0, effects_1.call)([antd_1.message, 'success'], 'Accounts reconciled successfully')];
            case 4:
                _a.sent();
                return [3, 7];
            case 5:
                e_2 = _a.sent();
                return [4, (0, effects_1.put)(actions.settleLedgerItemsRequestAction.failure(e_2))];
            case 6:
                _a.sent();
                return [3, 7];
            case 7: return [2];
        }
    });
}
exports.settleLedgerItems = settleLedgerItems;
function createOneOffLedgerItem(action) {
    var router, _a, accountId, activityPeriod, dueDate, details, startDate, endDate, oneOffLedgerItem, err_8, portalError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 7, , 11]);
                return [4, (0, effects_1.getContext)('Router')];
            case 1:
                router = _b.sent();
                _a = action.payload, accountId = _a.accountId, activityPeriod = _a.activityPeriod, dueDate = _a.dueDate, details = _a.details;
                startDate = activityPeriod[0], endDate = activityPeriod[1];
                return [4, (0, effects_1.call)([api_client_1.client, 'post'], '/finance/ledgerItems/oneOffs', {
                        accountId: accountId,
                        details: details,
                        dueDate: dueDate,
                        endDate: endDate,
                        startDate: startDate,
                    })];
            case 2:
                oneOffLedgerItem = (_b.sent()).data;
                return [4, (0, effects_1.put)(actions.createOneOffLedgerItemRequestAction.success(oneOffLedgerItem))];
            case 3:
                _b.sent();
                return [4, (0, effects_1.call)([router, 'push'], "/billing/payables/".concat(oneOffLedgerItem.id))];
            case 4:
                _b.sent();
                return [4, (0, effects_1.delay)(100)];
            case 5:
                _b.sent();
                return [4, (0, effects_1.call)([antd_1.message, 'success'], 'Payable created successfully')];
            case 6:
                _b.sent();
                return [3, 11];
            case 7:
                err_8 = _b.sent();
                portalError = (0, common_1.getPortalError)(err_8);
                return [4, (0, effects_1.put)(actions.createOneOffLedgerItemRequestAction.failure(portalError))];
            case 8:
                _b.sent();
                return [4, (0, effects_1.delay)(100)];
            case 9:
                _b.sent();
                return [4, (0, effects_1.call)([antd_1.message, 'error'], portalError.customError)];
            case 10:
                _b.sent();
                return [3, 11];
            case 11: return [2];
        }
    });
}
exports.createOneOffLedgerItem = createOneOffLedgerItem;
function addAdjustments(action) {
    var _a, accountId_1, ledgerItemId_1, adjustments, adjustmentForm, accountAdjustmentsData, e_3;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 8]);
                _a = action.payload, accountId_1 = _a.accountId, ledgerItemId_1 = _a.ledgerItemId, adjustments = _a.adjustments;
                adjustmentForm = adjustments === null || adjustments === void 0 ? void 0 : adjustments.map(function (adjustment) { return (__assign(__assign({}, adjustment), { accountId: accountId_1, ledgerItemId: ledgerItemId_1 })); });
                if (!adjustmentForm) return [3, 3];
                return [4, (0, effects_1.call)([api_client_1.client, 'post'], '/finance/accountAdjustments', adjustmentForm)];
            case 1:
                accountAdjustmentsData = (_b.sent()).data;
                return [4, (0, effects_1.put)(actions.payableAddAdjustmentAction.success(accountAdjustmentsData))];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3: return [4, (0, effects_1.delay)(100)];
            case 4:
                _b.sent();
                return [4, (0, effects_1.call)([antd_1.message, 'success'], 'Successfully added account adjustments.')];
            case 5:
                _b.sent();
                return [3, 8];
            case 6:
                e_3 = _b.sent();
                return [4, (0, effects_1.put)(actions.payableAddAdjustmentAction.failure(e_3))];
            case 7:
                _b.sent();
                return [3, 8];
            case 8: return [2];
        }
    });
}
exports.addAdjustments = addAdjustments;
function getPayableEventsById(action) {
    var events, err_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4, (0, effects_1.call)([api_client_1.client, 'get'], "/finance/ledgerItems/".concat(action.payload.id, "/events"))];
            case 1:
                events = (_a.sent()).data;
                return [4, (0, effects_1.put)(actions.payableEventsByIdRequestAction.success(events))];
            case 2:
                _a.sent();
                return [3, 5];
            case 3:
                err_9 = _a.sent();
                return [4, (0, effects_1.put)(actions.payableEventsByIdRequestAction.failure(err_9))];
            case 4:
                _a.sent();
                return [3, 5];
            case 5: return [2];
        }
    });
}
exports.getPayableEventsById = getPayableEventsById;
function getPayableDetailPage(action) {
    var id_1, payable, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 7]);
                id_1 = action.payload.id;
                return [4, (0, effects_1.call)(getPayableById, {
                        payload: { id: id_1 },
                        type: actionTypes_1.PayableActionType.GET_BY_ID_REQUEST,
                    })];
            case 1:
                _b.sent();
                return [4, (0, effects_1.select)(function (state) {
                        return (0, selectors_1.selectPayableById)(state, id_1);
                    })];
            case 2:
                payable = _b.sent();
                if (!payable) return [3, 5];
                return [4, (0, effects_1.put)(actions.payableEventsByIdRequestAction.request({ id: id_1 }))];
            case 3:
                _b.sent();
                return [4, (0, effects_1.put)(actions.payableAdjustmentsByLedgerItemIdRequestAction.request({
                        ledgerItemId: id_1,
                    }))];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [3, 7];
            case 6:
                _a = _b.sent();
                return [3, 7];
            case 7: return [2];
        }
    });
}
exports.getPayableDetailPage = getPayableDetailPage;
function payableSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, (0, effects_1.takeLatest)(actionTypes_1.PayableActionType.GET_EVENTS_BY_ID_REQUEST, getPayableEventsById)];
            case 1:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.PayableActionType.GET_DETAIL_PAGE, getPayableDetailPage)];
            case 2:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.PayableActionType.GET_ALL_REQUEST, getPayables)];
            case 3:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.PayableActionType.GET_BY_ID_REQUEST, getPayableById)];
            case 4:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.PayableActionType.GET_ALL_ADJUSTMENTS_REQUEST, getAdjustments)];
            case 5:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.PayableActionType.GET_ADJUSTMENTS_BY_LEDGER_ITEM_ID_REQUEST, getAdjustmentsByLedgerItemId)];
            case 6:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.PayableActionType.IGNORE_PAYABLE_REQUEST, ignorePayable)];
            case 7:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.PayableActionType.DELETE_ADJUSTMENT_REQUEST, deleteAdjustment)];
            case 8:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.PayableActionType.DELETE_PAYABLE_REQUEST, deletePayable)];
            case 9:
                _a.sent();
                return [4, (0, effects_1.takeEvery)(actionTypes_1.PayableActionType.REGENERATE_LEDGER_ITEMS_REQUEST, regenerateLedgerItems)];
            case 10:
                _a.sent();
                return [4, (0, effects_1.takeEvery)(actionTypes_1.PayableActionType.SETTLE_LEDGER_ITEMS_REQUEST, settleLedgerItems)];
            case 11:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.PayableActionType.CREATE_ONE_OFF_LEDGER_ITEM_REQUEST, createOneOffLedgerItem)];
            case 12:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.PayableActionType.ADD_ADJUSTMENT_REQUEST, addAdjustments)];
            case 13:
                _a.sent();
                return [2];
        }
    });
}
exports.payableSaga = payableSaga;
